module.exports = __webpack_public_path__ + "static/media/headerImg1.9740f821.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/NewPackSelector/headerImg1.svg
// module id = 1168
// module chunks = 0